// Form validation schema
export const LOGIN_FORM_VALIDATION = {
  loginId: {
    required: "Login ID is required",
  },
  password: {
    required: "Password is required",
  },
};

// Modal configuration
export const MODAL_CONFIG = {
  title: "Submit CVL Login Credentials",
  header: "Submit CVL Login Credentials",
  primaryBtnText: "Submit",
  modalPaperClassName: "tw-w-[429px]",
  secondaryBtnClassName: "tw-text-[#493ab1] tw-min-w-unset",
  footerClassName: "tw-justify-between tw-p-4 tw-h-unset",
};

// Form field configuration
export const FORM_FIELDS = {
  loginId: {
    name: "loginId",
    type: "text",
    label: "Login ID",
    placeholder: "Enter CVL Login ID",
  },
  password: {
    name: "password",
    type: "password",
    label: "Password",
    placeholder: "Enter CVL Password",
  },
};
